import React, { memo } from "react"

import { LightSelect, classnames } from "@cgtrader/triangle-ui/dist/src/ssr-index"
import { arrayOf, bool, func, shape, string } from "prop-types"

import useTranslation from "Pods/ThreeDStudio/Hooks/useTranslation"

// LightSelect has no disabled prop, so the wrapper modifier blocks pointer
// interaction (see _environment_settings.scss) and the change handler is gated.
function SurroundingSelect({
  options,
  value = null,
  onChange: handleChange,
  disabled = false,
}) {
  const t = useTranslation()

  return (
    <div
      className={classnames(
        'environment-settings__field',
        disabled && 'environment-settings__field--disabled',
      )}
      aria-disabled={disabled}
    >
      <span className="environment-settings__label cgt-body-base-semibold">{t('viewer.environment.surrounding')}</span>
      <LightSelect
        onChange={({ value: nextValue }) => !disabled && handleChange(nextValue)}
        name="environment-settings-surrounding"
        id="environment-settings-surrounding"
        options={options}
        value={value ?? ''}
        menuClassName="environment-settings__select-menu"
        placeholder={t('viewer.environment.showDefaultHdri')}
        size="small"
      />
    </div>
  )
}

SurroundingSelect.propTypes = {
  options: arrayOf(shape({
    value: string.isRequired,
    label: string.isRequired,
  })).isRequired,
  value: string,
  onChange: func.isRequired,
  disabled: bool,
}

export default memo(SurroundingSelect)
